/* eslint-disable */
import React, { useEffect, useState } from 'react';
import styles from './effortsCalculator.module.scss';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import BaseEffort from './BaseEffort/baseEffort';
import BufferCalculation from './BufferCalculation/bufferCalculation';
import Sdlc from './SDLC/sdlc';

const EffortsCalculator = () => {
  const [isMobileView, setIsMobileView] = useState(false);
  const [effortValue, setEffortValue] = useState('Base Effort');

  useEffect(() => {
    checkMobileView();
    window.scrollTo(0, 0);
  }, []);

  const handleChange = (event, newValue) => {
    setEffortValue(newValue);
  };

  const checkMobileView = () => {
    setIsMobileView(window.innerWidth <= 1100);
  };

  const effortsDisplay = () => {
    switch (effortValue) {
      case 'Base Effort':
        return <BaseEffort />;
      case 'Buffer Calculation':
        return <BufferCalculation />;
      case 'SDLC Efforts':
        return <Sdlc />;
      default:
        return <BaseEffort />;
    }
  };

  return (
    <div className={styles['effortsCalculator-container']}>
      <div className={styles['effortsCalculator-mainText']}>
        Effort Calculator
      </div>
      <Box sx={{ width: '100%' }} className={styles['effortsCalculator-tabs']}>
        <Tabs
          value={effortValue}
          textColor={'#6B5CE8'}
          indicatorColor={'#6B5CE8'}
          onChange={handleChange}
          sx={{
            '& .MuiTabs-indicator': {
              backgroundColor: '#6B5CE8',  // Custom indicator color
            },
            '& .Mui-selected': {
              color: '#6B5CE8 !important',  // Custom text color for selected tab
            },
          }}
          aria-label="wrapped label tabs example"
        >
          <Tab className={styles['tab']} value="Base Effort" label="Base Effort" sx={{minWidth:!isMobileView ? 200 :'auto',textTransform:'none', fontSize:!isMobileView ? 16:14, fontWeight: effortValue ==='Base Effort' ? '600':'400'}}/>
          <Tab className={styles['tab']} value="Buffer Calculation" label="Buffer Calculation" sx={{minWidth:!isMobileView ? 200 :'auto',textTransform:'none',  fontSize:!isMobileView ? 16:14, fontWeight: effortValue ==='Buffer Calculation' ? '600':'400'}}/>
          <Tab className={styles['tab']} value="SDLC Efforts" label="SDLC Efforts" sx={{minWidth:!isMobileView ? 200 :'auto',textTransform:'none',  fontSize:!isMobileView ? 16:14, fontWeight: effortValue ==='SDLC Efforts' ? '600':'400'}}/>
        </Tabs>
      </Box>
      {effortsDisplay()}
    </div>
  );
};

export default EffortsCalculator;
